import widget from './widget';
import settings from './settings';

export default {
  widget,
  settings,
  name: 'Box misspick chart',
  description: 'Displays misspick count per user'
};



// WEBPACK FOOTER //
// ./app/widgets.new/BoxMissPickChart/index.js